// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store/store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import validate from './utils/validate'
import md5 from 'js-md5'
import router from './router'

Vue.use(Vuex)
Vue.use(ElementUI)

Vue.prototype.axios = axios
Vue.prototype.$md5 = md5
Vue.prototype.validate = validate

Vue.config.productionTip = false

// eslint-disable-next-line no-extend-native
Array.prototype.indexOf = function (val) {
  for (let i = 0; i < this.length; i++) {
    if (this[i] === val) return i
  }
  return -1
}
// eslint-disable-next-line no-extend-native
Array.prototype.remove = function (val) {
  let index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}
Vue.prototype.clone = function (obj) {
  let copy = (obj instanceof Array) ? [] : {}
  for (let attr in obj) {
    if (!obj.hasOwnProperty(attr)) continue
    copy[attr] = (typeof obj[attr] === 'object') ? this.clone(obj[attr]) : obj[attr]
  }
  return copy
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js